export default "__VITE_ASSET__CvaFD0dg__"